export const baseStyles = {
    fontSize: 'sm',
};
